module.exports = __webpack_public_path__ + "static/media/pdp_popup_right_arrow_icon.26554ce0.svg";